import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

async function deleteDemoAccount(
  subscriptionId: string,
  auth: Authentication | null,
): Promise<void> {
  try {
    if (!auth) {
      throw new DeleteDemoAccountFailure('Vous devez être connecté pour effectuer cette action.', 'unauthorized');
    }
    await HttpClient.post(
      `/backoffice/demoaccount/delete`,
      { subscription_id: subscriptionId },
      auth.token,
    );
  } catch (e) {
    if (e instanceof DeleteDemoAccountFailure) throw e;
    const errMessage =
      e instanceof Error
        ? e.message
        : typeof e === 'string'
          ? e
          : 'Une erreur inattendue s’est produite.';
    throw new DeleteDemoAccountFailure(
      errMessage.trim() || 'Erreur réseau ou serveur. Réessayez plus tard.',
      'request-failed',
    );
  }
}

export class DeleteDemoAccountFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default deleteDemoAccount;
